module.exports = __webpack_public_path__ + "static/img/3e2579d1d80a72fbbd7ea3dfc6fc22b.ea2ac4e4.jpg";